// extracted by mini-css-extract-plugin
export default {"search_bar":"style_search_bar__Xl-mT","profile_btn":"style_profile_btn__q8Q9b"};